export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditSinisterPackages.vue?vue&type=template&id=64d070ae&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/EditSinisterPackages.vue?vue&type=template&id=64d070ae&scoped=true
// module id = 2083
// module chunks = 31